import { SVGProps, Ref, forwardRef } from 'react';

export const HrBrandOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path d="M3.95 14A4.5 4.5 0 0 1 8 11.516 4.5 4.5 0 0 1 12.05 14z" fill="currentColor" />
        <path d="M15 6.162c-1.656.22-3.12 1.337-3.67 2.992-.552 1.656-.04 3.4 1.168 4.528z" fill="currentColor" />
        <path d="M3.502 13.682c1.208-1.128 1.72-2.872 1.169-4.527S2.656 6.382 1 6.162z" fill="currentColor" />
        <path d="M8.278 1a4.34 4.34 0 0 0 1.78 4.333 4.58 4.58 0 0 0 4.772.314z" fill="currentColor" />
        <path d="M1.17 5.648a4.58 4.58 0 0 0 4.772-.314A4.34 4.34 0 0 0 7.722 1z" fill="currentColor" />
    </svg>
));
HrBrandOutlinedSize16Glyph.displayName = 'HrBrandOutlinedSize16Glyph';
